import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-645d3c86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rightContainer" }
const _hoisted_2 = { class: "monitor-detail" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, "监测详情", -1))
const _hoisted_4 = { class: "monitor-content" }
const _hoisted_5 = { class: "monitor-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "monitor-item-label" }, "监测时间：", -1))
const _hoisted_7 = { class: "monitor-item-text" }
const _hoisted_8 = { class: "monitor-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "monitor-item-label" }, "超标总数：", -1))
const _hoisted_10 = { class: "monitor-item-text" }
const _hoisted_11 = { class: "monitor-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "monitor-item-label" }, "涉及区域：", -1))
const _hoisted_13 = { class: "monitor-item-text" }
const _hoisted_14 = { class: "monitor-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "monitor-item-label" }, "疑似关联企业：", -1))
const _hoisted_16 = { class: "monitor-item-text" }
const _hoisted_17 = { class: "grid-detail" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, "网格详情", -1))
const _hoisted_19 = {
  class: "grid-content",
  ref: "gridContentRef"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "top-icon" }
const _hoisted_22 = { class: "icon-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_gridDetailVue = _resolveComponent("gridDetailVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "iconfont icon-close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeRightPanel && _ctx.closeRightPanel(...args)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString((_ctx.gridDataList?.monitorTime) ? _ctx.moment(_ctx.gridDataList?.monitorTime, 'YYYY-MM-DD HH:00').format('YYYY-MM-DD HH:00') : ''), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.gridDataList?.total), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.gridDataList?.zhen), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_Tooltip, { placement: "top" }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.gridDataList?.company), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.gridDataList?.company), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridDataList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "content-item",
            onClick: ($event: any) => (_ctx.clickGridChecked(index,item))
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(index+1), 1)
            ]),
            _createVNode(_component_gridDetailVue, {
              onUpdateLeftTable: _ctx.updateLeftTable,
              onTabClick: _ctx.tabClick,
              gridData: item,
              gridActive: _ctx.activeGridIndex===index,
              activeGrid: _ctx.activeGrid,
              onUpdateTicketDetail: _ctx.updateTicketDetail
            }, null, 8, ["onUpdateLeftTable", "onTabClick", "gridData", "gridActive", "activeGrid", "onUpdateTicketDetail"])
          ], 8, _hoisted_20))
        }), 128))
      ], 512)
    ])
  ]))
}